<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-6 bg-gradient-success">
      <div class="accordion" role="tablist">
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <h3 class="card-title"><b-button size="sm" v-b-toggle.accordion-1 variant="info"><i class="fa fa-filter"></i></b-button>Filtros </h3>

          </b-card-header>
          <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <!--b-card-text>I start opened because <code>visible</code> is <code>true</code></b-card-text>
              <b-card-text>{{ text }}</b-card-text>-->
              <b-form-group>
              <b-row>
                <b-col sm="3">
                     <b-input-group size="sm" prepend="Nro Caja">
                      <b-form-input size="sm" id="codigoCaja" type="text" v-on:change="onFiltroChange" v-model="filtro.codigoCaja" value="" placeholder="000"></b-form-input>
                    </b-input-group>
                </b-col>
                <b-col sm="3">
                    <b-row>
                      <b-col sm="6">
                        <b-input-group size="sm" prepend="NroFactura">
                          <b-form-input size="sm" id="nroFactura" type="text" v-on:change="onFiltroChange" v-model="filtro.nroFactura" value="" placeholder="000"></b-form-input>
                        </b-input-group>
                      </b-col>
                      <b-col sm="6">
                        <b-input-group size="sm" prepend="Documento">
                          <b-form-input size="sm" id="nroDocumento" type="text" v-on:change="onFiltroChange" v-model="filtro.nroDocumento" value="" placeholder="000"></b-form-input>
                        </b-input-group>
                      </b-col>
                    </b-row>
                </b-col>
                <b-col sm="3">
                  <b-input-group size="sm" prepend="Turno">
                    <b-form-input size="sm" id="nroTurno" type="text" v-on:change="onFiltroChange" v-model="filtro.idTurno" value="" placeholder="0000"></b-form-input>
                  </b-input-group>
                </b-col>
                <b-col sm="3" class="text-center">
                        <b-button title="Aplicar filtro" :class="{'btn btn-success' :filtroActivo, 'btn btn-light':!filtroActivo}" @click="aplicarFiltro()"><i :class="{'fas fa-check':filtroActivo,'fas fa-ban':!filtroActivo}"></i></b-button>
                        <b-button title="Resetear filtro" variant="primary" @click="resetFiltro()"><i class="fas fa-undo"></i></b-button>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="3">
                    <b-input-group size="sm" prepend="Cajera">
                      <b-form-input size="sm" id="nombreCajera" type="text" v-on:change="onFiltroChange" v-model="filtro.nombreCajera" value="" placeholder="María Perez"></b-form-input>
                    </b-input-group>
                </b-col>
                <b-col sm="3">
                  <b-input-group size="sm" prepend="Rif/Cédula">
                    <b-form-input size="sm" id="cedula" type="text" v-on:change="onFiltroChange" v-model="filtro.cedula" value="" placeholder="0000000"></b-form-input>
                  </b-input-group>
                </b-col>
                <b-col sm="3">
                  <b-input-group size="sm" prepend="Tipo Pago">
                    <select name="formaPagoId" v-on:change="onFiltroChange" v-model="filtro.formaPagoId" id="formaPagoId" class="form-control form-control-sm" :class="{ 'is-invalid': filtro.errors.has('formaPagoId') }">
                        <option value="-1">Todos Formas de Pago</option>
                        <option v-for="itemc in formasPago" :value="itemc.id"  v-bind:key="itemc.id">
                            {{itemc.descripcion}}
                        </option>
                    </select>
                  </b-input-group>
                </b-col>
              </b-row>
              <b-row class="mt-3">
                  <b-col sm="3">
                    <b-form-input class="form-control form-control-sm float-right" id="fechaI" type="date" v-on:change="onFiltroChange" v-model="filtro.fechaI" name="fechaI" min="01-01-2000"
              max="31-12-3000"></b-form-input>
                  </b-col>
                  <b-col sm="3">
                    <b-form-input size="sm" id="fechaF" type="date" v-on:change="onFiltroChange" v-model="filtro.fechaF" name="fechaF" min="01-01-2000"
                max="31-12-3000"></b-form-input>
                  </b-col>
                  <b-col sm="3">
                    <select name="estatus" v-on:change="onFiltroChange" v-model="filtro.estatus" id="estatus" class="form-control form-control-sm" :class="{ 'is-invalid': filtro.errors.has('estatus') }">
                        <option value="-1">Todos los Estatus</option>
                        <option value="0">Creado</option>
                        <option value="1">Impreso</option>
                        <option value="2">Anulado</option>
                        <option value="3">Devolución Parcial</option>
                        <option value="4">Devolución Total</option>
                    </select>
                  </b-col>
              </b-row>
              </b-form-group>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
    </base-header>
    <b-container fluid class="mt--7">
      <b-row>
        <b-col>
        <b-card no-body>
            <b-card-header class="border-0">
                <h3 class="mb-0">Listado de  Facturas</h3>
            </b-card-header>
            <div class="card-body table-responsive p-0">
                    <table class="table table-hover text-center">
                      <tbody>
                        <tr class="thead-light">
                            <th>Fecha/Hora</th>
                            <th>Documento</th>
                            <th>Nro Factura</th>
                            <th>Turno</th>
                            <th>Monto Pagado Bs</th>
                            <th>Tasa</th>
                            <th>Estatus</th>
                            <th>Acciones</th>
                      </tr>
                      <tr v-for="factura in facturas" :key="factura.id">
                        <td>{{factura.fecha | myDateTime}}</td>
                        <td>{{factura.numeroControl}}</td>
                        <td>{{factura.numeroFactura}}</td>
                        <td>{{factura.turnoId}}</td>
                        <td class="text-right">{{factura.montoPagado | moneda}}</td>
                        <td class="text-right">{{factura.tasa | moneda}}</td>
                        <td><span :class="{'badge badge-danger':factura.estatus===4, 'badge badge-warning':factura.estatus===3, 'badge badge-success':factura.estatus===1,'badge badge-danger':factura.estatus===2,'badge badge-default':factura.estatus===0 }">{{factura.estatus | statusFactura}}</span></td>
                        <td>
                            <base-button size="sm" type="secondary" title="Ver Factura" @click="verDetalleFactura(factura)">
                              <i class="fa fa-tasks"></i>
                            </base-button>
                            <base-button v-if="$gate.isAllAdminOrUsers() && (factura.estatus == 0 )" size="sm" type="success" @click="actualizarFactura(factura)">
                              <i class="fas fa-sync"></i>
                            </base-button>
                            <base-button v-if="$gate.isAllAdminOrUsers() && factura.estatus == 0" title="Anular Factura" size="sm" type="danger" @click="anularFactura(factura)">
                              <i class="fas fa-minus-circle"></i>
                            </base-button>
                            <!--<base-button v-if="$gate.isAdminOrAuthor()" size="sm" type="danger" @click="deletefactura(factura.id)">
                                <i class="fa fa-trash"></i>
                            </base-button>-->
                        </td>
                      </tr>
                    </tbody></table>
                <!-- /.card -->
            </div>
            <b-card-footer class="py-4 d-flex justify-content-end">
                <base-pagination @change="getResults"  v-model="currentPage" :per-page="perPage" :total="totalItemsRow"></base-pagination>
            </b-card-footer>
        </b-card>
          <!--<light-table/>
          <dark-table/>-->
        </b-col>
      </b-row>
      <div class="mt-5"></div>
    </b-container>

    <!-- Modal Detalle Producto-->
    <b-modal ref="modal-detalleProducto" size="md" title="Detalle de Factura" ok-only>
      <b-list-group-item href="javascript:;" class=" flex-column align-items-start py-4 px-4">
        <div class="d-flex w-100 justify-content-between">
          <div>
            <div class="d-flex w-100 align-items-center">
              <img src="img/theme/producto.png" alt="Image placeholder" class="avatar avatar-xs mr-2">
              <h5 class="mb-1">{{productoActual.descripcion}}</h5>
            </div>
          </div>
          <small>Fecha: {{productoActual.fecha | myDate}}</small>
        </div>
        <h4 class="mt-3 mb-1">Código: {{productoActual.codigoProducto }}</h4>
        <b-list-group flush>
          <b-list-group-item href="#">Precio: {{productoActual.precioBolivar | moneda}} Bs.</b-list-group-item>
          <b-list-group-item href="#">Precio: {{productoActual.precioDolar | moneda}} $</b-list-group-item>
          <b-list-group-item href="#">Tasa: {{productoActual.tasa}} Bs.</b-list-group-item>
        </b-list-group>
      </b-list-group-item>
    </b-modal>

      <!-- Detalle pago -->
      <b-modal ref="modal-DetalleFactura" hide-backdrop  size="xl" ok-only>
        <template #modal-title>
          <h5 class="modal-title">Detalle de Factura</h5>
        </template>
        <p>
          <!--Total Dolares: {{detalleMoneda[0].totalMoneda | moneda}} - Total Bolivares: {{detalleMoneda[1].totalMoneda | moneda}}
          <b-button v-b-modal.modal-multi-3 size="sm">Open Third Modal</b-button>-->
        </p>
        <table width="100%" class="detallefactura table-bordered">
          <tr>
            <th width="12%">Documento:</th>
            <td><b>{{facturaActual.numeroControl}}</b></td>
            <th>Tasa:</th>
            <td class="fondotasa text-right">{{facturaActual.tasa | moneda}} Bs.</td>
          </tr>
          <tr>
            <th>Cliente:</th>
            <td>{{detalleDeFactura.cliente.nombre}} {{detalleDeFactura.cliente.apellido}}</td>
            <th>Teléfono:</th>
            <td>{{detalleDeFactura.cliente.telefono}}</td>
          </tr>
          <tr>
            <th>RIF/C.I:</th>
            <td>{{detalleDeFactura.cliente.cedRif}}</td>
            <th>Cod. Afil.:</th>
            <td>00999</td>
          </tr>
          <tr>
            <th>Dir.:</th>
            <td colspan="3">{{detalleDeFactura.cliente.direccion}}</td>
          </tr>
          <tr>
            <th>Cajero:</th>
            <td>{{cajero.nombre}} {{cajero.apellido}}</td>
            <th>Caja:</th>
            <td>{{cajero.codigoCaja}}</td>
          </tr>
          <tr>
            <th>Factura:</th>
            <td colspan="3"><b>{{facturaActual.numeroFactura}}</b></td>
          </tr>
          <tr>
            <th>Fecha:</th>
            <td colspan="3">{{facturaActual.fecha | myDateTime}}</td>
          </tr>
        </table>
        <table class="table table-hover table-bordered">
          <tr class="thead-light">
            <th>DESCRIPCION</th>
            <th>CANT</th>
            <th>PRECIO</th>
            <th>TOTAL</th>
          </tr>
          <tbody>
          <tr v-for="df in detalleDeFactura.detalleFactura" :key="df.codigoProducto" @click="verDetalleProducto(df)"
           :class="{'bckgdevolucion':df.cantidad<0}"
          >
            <td>{{df.descripcion}}</td>
            <td>{{df.cantidad}}</td>
            <td class="text-right">{{df.precioBolivar | moneda}}</td>
            <td class="text-right">{{df.total | moneda}}</td>
          </tr>
          </tbody>
          <tr>
            <th colspan="3" scope="row">SUBTOTAL</th>
            <td class="text-right">{{totalGeneralBs | moneda}}</td>
          </tr>
          <tr>
            <th colspan="3" scope="row">IMPUESTO</th>
            <td class="text-right"><!--{{facturaActual.montoIVAbs | moneda}}--></td>
          </tr>
          <tr v-if="facturaActual.montoDescuentobs>0">
            <th colspan="3" scope="row">DESCUENTO</th>
            <td class="text-right">- {{facturaActual.montoDescuentobs | moneda}}</td>
          </tr>
          <tr>
            <th colspan="3" scope="row">TOTAL BS</th>
            <td class="text-right bckgmontobs">{{totalGeneralBs| moneda}}</td>
          </tr>
          <tr>
            <th colspan="3" scope="row">TOTAL $</th>
            <td class="text-right bckgmontobs">{{totalGeneralBs/facturaActual.tasa| moneda}}</td>
          </tr>
        </table>
        <table class="detallefactura table-bordered">
          <tr>
            <th width="50%">Forma de Pago:</th>
            <th>Monto</th>
          </tr>
          <tr width="50%" v-for="fpf in formasPagoFactura" :key="fpf.id">
            <th>{{fpf.descripcion}}</th>
            <td class="text-right">{{fpf.monto | moneda}}</td>
          </tr>
        </table>
        <template #modal-footer="{ close }">
          <div class="w-100">
            <b-button
              variant="primary"
              size="sm"
              class="float-right"
              @click="close()"
            >
              Cerrar
            </b-button>
          </div>
        </template>
      </b-modal>
  </div>
</template>
<script>
  import { Dropdown, DropdownItem, DropdownMenu, Table, TableColumn } from 'element-ui';
  export default {
    components: {
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn
    },
    data() {
      return {
      editmode: false,
      filtroActivo:false,
      perPage:10,
      currentPage: 1,
      totalItemsRow:10,
      detalleDeFactura:{
        cliente: {
          apellido: "",
          cedRif: "",
          direccion: "",
          nombre: "",
          telefono: ""}
        ,detalleFactura:[]},
      cajero:{
          accionesAdc: null,
          apellido: "",
          cedula: "",
          createdAt: "",
          estatus: 1,
          id: 1,
          nick: "",
          nombre: "",
          password: "",
          rolId: 0,
          sucursal: 0,
          tipo: 0,
          updatedAt: "",
          codigoCaja:""
      },
      monedaSelect:1,
      tipoMoneda:[{id:1, detalle:'Bs.'},{id:2, detalle:'$'}],//1:Bolivar, 2:Dolar
      facturas:[],
      turnos:[],
      formasPago:[],
      facturaActual:{},
      productoActual:{},
      formasPagoFactura:{},
      filtro: new Form({
        nroFactura: '',
        codigoCaja: '',
        nroDocumento: '',
        idTurno: 0,
        Caja: 0,
        fechaI: this.getDate(),
        fechaF: this.getDate(),
        cedula:'',
        monto: 0,
        estatus: "-1",
      }),
        status: [{value:true, text:"Activo"}, {value:false, text:"Inactivo"}],
        factMayor: [{value:true, text:"Si"}, {value:false, text:"No"}],
        selectTienda:[{value:"", text:"Seleccione"}]
      };
    },
    methods: {
      async getResults(page = 1) {
        //this.filtro.nro
        await axios.get(this.$gate.getApiUrl()+'CajaAdministrativa/ReporteFacturas?page='+page+'&perPage='+this.perPage,{ params: this.filtro })
        .then(({ data }) => {
          this.facturas = data.facturas;
          this.totalItemsRow = data.totalrow;
        }).catch( e => {
            /* si el token es invalido o esta vencido */
            if (e.response.status == 401) {
               this.$gate.removeLogin();
               this.$router.push("/Login");
            }
        });
      },
      editModal(caja){
        this.editmode = true;
        this.form.reset();
        this.$refs['modal-1'].show();
        //$('#addNew').modal('show');
        this.form.fill(caja);
      },
      actualizarFactura: async function(factura){
            this.$swal({
              title: 'Esta Segur@ de Actualizar La Factura Nro '+factura.numeroFactura+' ?',
              text: 'Los datos se almacenarán al aceptar!',
              icon: 'info',
              showCancelButton: true,
              confirmButtonText: 'Si, Guardar!',
              cancelButtonText: 'No'
            }).then((result) => {
              if (result.value) {
                //---------Accion actualizar Factura
                axios.post(this.$gate.getApiUrl()+'CajaAdministrativa', {
                    facturaId: factura.facturaId,
                    userId: this.$store.state.user.id
                }).then(response => {
                    // Respuesta del servidor
                    this.$swal({
                      title: 'Factura Actualizada a Impresa',
                      icon: 'success',
                      showConfirmButton: false,
                      toast: true,
                      position: 'top-end',
                      timer: 3000
                    })
                    this.getResults(this.currentPage);
                }).catch(e => {
                  this.$swal({
                    title: 'Error Actualizando Factura',
                    icon: 'error',
                    showConfirmButton: false,
                    toast: true,
                    position: 'top-end',
                    timer: 3000
                  })
                });

              }else if (result.dismiss === this.swal.DismissReason.cancel) {
                this.$swal(
                  'Cancelled',
                  'Ha ocurrido un error verifique la informacion e intente nuevamente',
                  'error'
                )
              }
            })
      },
      anularFactura: async function(factura){

        this.$swal({
          title: 'Esta Segur@ de Anular La Factura Nro '+factura.numeroFactura+' ?',
          text: 'La factura se anula al aceptar!',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Si, Anular!',
          cancelButtonText: 'No'
        }).then((result) => {
          if (result.value) {
            axios.post(this.$gate.getApiUrl()+'CajaAdministrativa/AnularFactura', {
                facturaId: factura.facturaId,
                userId: this.$store.state.user.id
            }).then(response => {
                // Respuesta del servidor
                this.$swal({
                  title: 'Factura Actualizada',
                  icon: 'success',
                  showConfirmButton: false,
                  toast: true,
                  position: 'top-end',
                  timer: 3000
                })
                this.getResults(this.currentPage);
            }).catch(e => {
              this.$swal({
                title: 'Error Actualizando Factura',
                icon: 'error',
                showConfirmButton: false,
                toast: true,
                position: 'top-end',
                timer: 3000
              })
            });
          }else if (result.dismiss === this.swal.DismissReason.cancel) {
            this.$swal(
              'Cancelled',
              'Ha ocurrido un error verifique la informacion e intente nuevamente',
              'error'
            )
          }
        })
      },
      aplicarFiltro(){
        //if(this.$gate.isAdmin()){
          let loader = this.$loading.show({
            // Optional parameters
            container: this.fullPage ? null : this.$refs.formContainer,
            canCancel: true,
            loader: 'dots',
          });
          this.getResults();
          loader.hide();
      },
      resetFiltro(){
        this.filtro.reset();
        this.filtroActivo = false;
        this.getResults();
      },
      onFiltroChange(){
        this.filtroActivo = true;
      },
      verDetalleFactura: async function(factura){
        this.facturaActual = factura;
        await axios.get(this.$gate.getApiUrl()+"CajaAdministrativa/DetalleFactura?CajaId="+factura.cajaId+"&Factura="+factura.numeroFactura+"&ClienteId="+factura.clienteId+"&Fecha="+this.filtro.fechaI).then(({ data }) => {this.detalleDeFactura = data.data;});
        await axios.get(this.$gate.getApiUrl()+"CajaAdministrativa/DetalleCajeraTurno/"+factura.turnoId).then(({ data }) => {this.cajero = data.data.cajeraTurno; this.cajero.codigoCaja = data.data.cajaTurno.codigoCaja; });
        await axios.get(this.$gate.getApiUrl()+"CajaAdministrativa/FormaPago/Factura/"+factura.facturaId).then(({ data }) => {this.formasPagoFactura = data.data; });
        this.$refs['modal-DetalleFactura'].show();
      },
      verDetalleProducto(df){
        this.productoActual = df;
        this.$refs['modal-detalleProducto'].show();
      },
      getDate(){
        var currentDate = new Date();
        return currentDate.getFullYear()+"-"+(currentDate.getMonth()<9?"0"+(currentDate.getMonth()+1):(currentDate.getMonth()+1))+"-"+(currentDate.getDate()<10?"0"+currentDate.getDate():currentDate.getDate());
      },
      /*editModal(caja){
        this.editmode = true;
        this.form.reset();
        this.$refs['modal-1'].show();
        //$('#addNew').modal('show');
        this.form.fill(caja);
      },*/
      updateCaja(){
        console.log('Actualizar Data');
        this.hideModal();
      },
      hideModal() {
        this.$refs['modal-1'].hide();
      },
      getHora(){
        var currentDate = new Date();
        var hora = currentDate.getHours();
        var min = currentDate.getMinutes();
        //var seg = currentDate.getSeconds();
        return (hora<10?("0"+hora):hora)+":"+(min<10?("0"+min):min);
      },
      calculardiferencia(hora_desde="12:00T12:00"){
        var hora_inicio = hora_desde.split("T")[1];
        hora_inicio = hora_inicio.slice(0, 5);
        //var hora_iniciop = hora_desde;
        var hora_final = this.getHora();

        if(hora_desde > hora_final){
          hora_inicio = hora_final;
          hora_final = hora_desde;
        }


        // Expresión regular para comprobar formato
        var formatohora = /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/;

        // Si algún valor no tiene formato correcto sale
        if (!(hora_inicio.match(formatohora)
              && hora_final.match(formatohora))){
          return;
        }

        // Calcula los minutos de cada hora
        var minutos_inicio = hora_inicio.split(':')
          .reduce((p, c) => parseInt(p) * 60 + parseInt(c));
        var minutos_final = hora_final.split(':')
          .reduce((p, c) => parseInt(p) * 60 + parseInt(c));

        // Si la hora final es anterior a la hora inicial sale
        if (minutos_final < minutos_inicio) return;

        // Diferencia de minutos
        var diferencia = minutos_final - minutos_inicio;

        // Cálculo de horas y minutos de la diferencia
        var horas = Math.floor(diferencia / 60);
        var minutos = diferencia % 60;

        return horas + ':' + (minutos < 10 ? '0' : '') + minutos;
      },
      zfill(number, width=6) {
          var numberOutput = Math.abs(number); /* Valor absoluto del número */
          var length = number.toString().length; /* Largo del número */
          var zero = "0"; /* String de cero */

          if (width <= length) {
              if (number < 0) {
                  return ("-" + numberOutput.toString());
              } else {
                  return numberOutput.toString();
              }
          } else {
              if (number < 0) {
                  return ("-" + (zero.repeat(width - length)) + numberOutput.toString());
              } else {
                  return ((zero.repeat(width - length)) + numberOutput.toString());
              }
          }
      },
      async loadFacturas(){
        if (this.$route.query.hasOwnProperty('fecha')) {
          this.filtro.fechaI = this.$route.query.fecha;
          this.filtro.fechaF = this.$route.query.fecha;
          this.filtro.cedula = this.$route.query.rif;
        }
        this.getResults();
        await axios.get(this.$gate.getApiUrl()+"FormaPago").then(({ data }) => {this.formasPago = data; });
      },

    },
    computed: {
      totalGeneralBs: function(){

        let total = [];

        Object.entries(this.detalleDeFactura.detalleFactura).forEach(([key, val]) => {
            total.push(parseFloat(val.total)) // the value of the current key.
        });

        return total.reduce(function(total, num){ return total + num }, 0);

      },
      totalGeneralDolar: function(){

        let total = [];

        Object.entries(this.detalleDeFactura.detalleFactura).forEach(([key, val]) => {
            total.push(parseFloat(val.total)/parseInt(val.tasa)) // the value of the current key.
        });

        return total.reduce(function(total, num){ return total + num }, 0);

      },
      promedioTasaDolar: function(){
        var sumatoriaObjeto = this.facturas.reduce(function(acumulador, siguienteValor){
          return {
            tasa: acumulador.tasa + siguienteValor.tasa
          };
        }, {tasa: 0}); //Si no hay nada, regresamos un objeto con edad = 0. No hay necesidad de devolver el nombre, pues no es necesario

        return sumatoriaObjeto.tasa / this.facturas.length;
      },
    },
    created(){
      this.loadFacturas();
    }
  };
</script>
<style>
 .statscard{
   font-size: 13px;
 }
 .fondotasa{
   background: #f5f5f5;
   font-weight: bold;
 }

 .bckgdevolucion{
   background: #f3bdbb;
   font-weight: bold;
 }

 .detallefactura {
    font-size: 0.8125rem;
    white-space: nowrap;
 }
 .bckgmontobs{
   background: #e2e6e7;
   font-weight: bold;
 }
</style>
